import type { TourSpec } from "./types";

export const snipeTour: TourSpec = {
  id: "snipe",
  // v2: adds the import-preview and inline price editing steps — bumping the
  // version re-shows the tour once to users who completed v1.
  version: 2,
  buildSteps: (t) => [
    {
      target: '[data-tour="snipe-add-alert-button"]',
      title: t("snipe.add.title"),
      content: t("snipe.add.body"),
      placement: "bottom",
      skipBeacon: true,
    },
    {
      target: '[data-tour="snipe-tab-navigation"]',
      title: t("snipe.tabs.title"),
      content: t("snipe.tabs.body"),
      placement: "bottom",
    },
    {
      target: '[data-tour="snipe-import-controls"]',
      title: t("snipe.import.title"),
      content: t("snipe.import.body"),
      placement: "bottom",
    },
    {
      target: '[data-tour="snipe-alerts-table"]',
      title: t("snipe.list.title"),
      content: t("snipe.list.body"),
      placement: "top",
    },
    {
      target: '[data-tour="snipe-alerts-table"]',
      title: t("snipe.inlineEdit.title"),
      content: t("snipe.inlineEdit.body"),
      placement: "top",
    },
  ],
};
